module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-08-24 at 14.51.10.0f2fa1f5.png";